export const INSTANT_PAY_FUNDING_PARTNER = 'Bank of New York';
